import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { GameProvider, useGame } from "@/context/GameContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import ChildPicker from "@/pages/ChildPicker";
import Home from "@/pages/Home";
import Subject from "@/pages/Subject";
import Lesson from "@/pages/Lesson";
import Pet from "@/pages/Pet";
import Rewards from "@/pages/Rewards";
import Settings from "@/pages/Settings";
import ParentLogin from "@/pages/ParentLogin";
import ParentDashboard from "@/pages/ParentDashboard";

function Splash() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-sky-100">
      <div className="animate-float font-display text-4xl font-bold text-sky-500">SpeelSlim…</div>
    </div>
  );
}

function RequireActiveChild({ children }) {
  const { profile, loading } = useGame();
  if (loading) return <Splash />;
  if (!profile) return <Navigate to="/" replace />;
  return children;
}

// Root: not logged-in parents see the Landing; logged-in parents pick a child.
function Root() {
  const { user } = useAuth();
  const { loading } = useGame();
  if (user === null || loading) return <Splash />;
  if (!user) return <Landing />;
  return <ChildPicker />;
}

function RequireParent({ children }) {
  const { user } = useAuth();
  if (user === null) return <Splash />;
  if (!user) return <Navigate to="/ouders" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <GameProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Root />} />
              <Route path="/ouders" element={<ParentLogin />} />
              <Route path="/ouders/dashboard" element={<RequireParent><ParentDashboard /></RequireParent>} />
              <Route path="/spelen" element={<RequireActiveChild><Home /></RequireActiveChild>} />
              <Route path="/vak/:subjectId" element={<RequireActiveChild><Subject /></RequireActiveChild>} />
              <Route path="/les/:subjectId/:lessonId" element={<RequireActiveChild><Lesson /></RequireActiveChild>} />
              <Route path="/huisdier" element={<RequireActiveChild><Pet /></RequireActiveChild>} />
              <Route path="/beloningen" element={<RequireActiveChild><Rewards /></RequireActiveChild>} />
              <Route path="/instellingen" element={<RequireActiveChild><Settings /></RequireActiveChild>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" />
        </GameProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
